import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

export const content = css({
  tabletDown: {
    px: 16,
  },
});

export const filterSection = flex({
  justify: 'flex-start',
  align: 'center',
  w: '100%',
  my: { base: 24, tablet: 30 },
  tabletDown: {
    flexDirection: 'column',
    gap: 12,
    alignItems: 'flex-start',
  },
});

export const left = flex({
  justify: 'flex-start',
  align: 'center',
  gap: 12,
  flex: 1,
});

export const description = css({
  textStyle: 'Text/L/Regular',
  color: 'content.default.level-3',
});

export const card = css({
  '& dt': {
    textStyle: 'Text/S/Regular',
    color: 'content.default.level-2',
  },
  '& dd': {
    textStyle: 'Text/M/Regular',
    color: 'content.default.level-5',
  },
});

export const horizontal = flex({
  justify: 'space-between',
  align: 'flex-start',
  w: '100%',
  '& + div': {
    mt: 8,
  },
});

export const vertical = css({
  w: '100%',
  '& + div': {
    mt: 16,
  },
  '& dt': {
    mb: 4,
  },
});

export const hLine = css({
  w: '100%',
  h: 1,
  m: '12px 0',
  bgColor: 'border.default.level-3',
  border: 'none',
});

export const fromToAmount = flex({
  align: 'center',
  justify: 'flex-start',
  gap: 8,
});

export const currencyStyle = flex({
  gap: 4,
  textStyle: 'Text/M/Regular',
});

export const intervalSelector = css({
  tablet: { maxW: '224px!' },
});

export const symbolRow = flex({
  justify: 'space-between',
  align: 'center',
  tabletDown: {
    mb: 12,
  },
});
